import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { Feature } from '@nirvana/shared/constants';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class UnassignVcenterRoleValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  protected canRunOnCompanionRecords = false;
  protected canRunForMultipleItems = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!record.specifics.isManaged) {
      return false;
    }

    if (!ProtectedEntitiesHelper.isUnifiedClient(record)) {
      return false;
    }

    if (!record.specifics.isVmwareSyncer) {
      return false;
    }

    // can only be type_computer or type_vmware_virtual_machine
    if (![Constants.ProtectedEntities.EPS.TYPE_COMPUTER, Constants.ProtectedEntities.EPS.VMWARE_VIRTUAL_MACHINE].includes(record.type)) {
      return false;
    }

    return true;
  }
}
